import { gql } from '../../../../../hooks'

export const READ_IMAGES = gql`
  query AdministrationReadReportImages($id: ID!) {
    aRead(path: "other/images", id: $id) {
    }
  }
`
